<template>
    <div>
        <Navigation />
        <section class="section__container spacer-8">
            <div class="job">
                <h1 class="job__title">SERVICES-SMS RECRUTE</h1>
                <p class="job__description">
                    <strong>Servicesms.sn est une plateforme de marketing par SMS en expansion rapide, 
                    offrant un soutien aux entreprises pour améliorer leur efficacité  <br/>tout en 
                    maintenant une connexion constante avec leur clientèle.</strong>
                </p>
            </div>
        </section>
        <section class="quote container">
            <p class="quote__description">
                Servicesms.sn propose un milieu de travail propice à la productivité, axé sur le développement
                et l'innovation. Étant donné que la satisfaction du client est au centre de nos préoccupations, 
                notre environnement de travail est stimulant et gratifiant pour l'ensemble de notre équipe.


            </p>
            <div class="founder ">
                <img class="founder__img" src="/../images/quote.png" alt="founder">
                <p class="founder__title">
                    Harouna Sylla  <br>
                    <span class="cto"> Fondateur & CEO – SERVICES-SMS</span>
                </p>

            </div>
        </section>
        <section class="opening">
            <h2 class="opening__title">Opportunités d'emploi en cours</h2>
            <div class="container opening_cards">
                
                 <router-link class=" position__desc opening__card" to="/firstjob">
                    <p>Commercial(e) Sédentaire</p>
                 </router-link>
                 <router-link class=" position__desc opening__card" to="/secondjob">
                    <p>Stagiaire en Marketing Digital Pré-Embauche</p>
                 </router-link>
                 <router-link class=" position__desc opening__card" to="/thirdjob">
                    <p>un(e) analyste développeur (H/F) </p>
                 </router-link>
                 
                 <router-link class=" position__desc opening__card" to="/fifthjob">
                    <p>Développeur plugins/API (H/F) - Stage</p>
                 </router-link>
                 


                
            </div>


        </section>

        <section class="team container">
            <div class="second__team">
                <h2>Notre équipe technique
                </h2>
                <p class="team_desc">
                    Nous privilégions une approche moderne avec les méthodologies agiles et scrum, respectant les normes
                    de l'industrie. La veille technologique et la formation continue de nos équipes sont cruciales.
                    En collaboration avec des experts, nous enrichissons notre expertise, assurant ainsi notre position
                    de leader par une évolution constante sur le marché.
 
                </p>
            </div>
            <div class="second__team">
                <h2>Équipe commerciale dédiée
                </h2>
                <p class="team_desc">
                    Notre équipe est dévouée au succès de l'entreprise. Les réunions quotidiennes renforcent notre synergie.
                    L'indépendance est clé, encourageant la liberté d'idées et d'actions. En tant que start-up, nous apprécions
                    la collaboration avec des individus autonomes résolus à offrir une réelle valeur à nos clients.

                </p>
            </div>
        </section>
        <Footer/>
    </div>
</template>

<script>
import Navigation from "./Navigation";
import Footer from './Footer';
export default {
    components: {
        Navigation,
        Footer
    }
}
</script>

<style lang="scss" scoped>
@import "../assets/base.scss";

.job__title {
    text-align: center;
    padding-top: 1.5rem;

}

.quote {
    background: $color-tertiary;
    border-radius: 20px 20px 20px 0;
    color: $color-white;
}
.team_desc{
    text-align: justify;
}

a{
    text-decoration: none;
    list-style-type: none;
    color: #000;
}
.job {
    background: #d8e8f4;
}

.job__description {
    padding: 1rem;
    text-align: center;
}

.quote__description {
    padding: 1rem;

}

.founder__title {
    font-weight: bold;

}

.cto {
    font-weight: 100;
    font-size: 1rem;
}

.founder__img {
    width: 80px;
    height: 80px;
}

.founder {
    display: flex;
    padding-left: 1rem;
    align-items: center;
}

.founder__title {
    padding-left: 1rem;
    padding-top: 1rem;
}

.opening {
    &__title {
        text-align: center;
    }

    &__card {
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 85px;
        background-color: #fff;
        font-size:.9rem;
        border-radius: 20px 20px 20px 0;
        margin-bottom: 1rem;

        &:hover {
            background: $color-tertiary;
            color: $color-white;
            transition: all ease 250ms;


        }

    }


    -webkit-font-smoothing: antialiased;
    background: #ecf0f4;

}

.position__desc::before {
    content: "";
    width: 15px;
    height: 15px;
    background: url(../../public/images/picto-list.svg) no-repeat center;
    padding-left: 2rem;
}

.position__desc:hover {
    background-color: #158ce7;

}

@media (min-width: 64rem) {
    .spacer-8 {
        margin-top: 8rem;
    }

    .quote {
        width: 60%;
        margin: 0 auto;
        font-size: 1.25rem;
    }
    .job{
        position: relative;
        z-index: -1;
        top: 2rem;
    }


    .job__description {
        font-size: 1.125rem;
    }

    .opening_cards {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 1rem;
        width: 60%;
        margin: 0 auto;

    }
    .team{
         display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 4rem;
          width: 60%;
          margin: 0 auto;
    }
}</style>